import { ThermometerCheckIcon } from './ThermometerCheckIcon';

/**
 * author: Michael Irigoyen
 * id E01A628C-01EA-4F7E-B150-FCCDBED99EF9
 * name thermometer-check
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/thermometer-check.svg
 * tags
 * - Weather 
 * - Home Automation 
 */
export const ThermometerApproveIcon = ThermometerCheckIcon;
export default ThermometerApproveIcon